import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import {
  quick_quotes_Bike,
  QuickQuote_Post,
  Err_quotes,
} from "../../Redux/actions/NumBikeation";
import { Button, Form, DatePicker, message } from "antd/lib";
import moment from "moment";

export default function Prevpolexp({ setisModalExp }) {
  const dispatch = useDispatch();
  const QuickQuotes = useSelector(
    (state) => state.vehicledetail.quickquotes.data
  );
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector(
    (state) => state.vehicledetail.quickQuotePost
  );
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [loading, setLoading] = useState(false);

  const onFinish = (data) => {
    console.log("product data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuotePost,
      previousPolicyExpiryDate: moment(data.previousPolicyExpiryDate).format(
        "YYYY-MM-DD"
      ),
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInstance
      .post(
        `v2/bike_insurances/${auth.bike_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          // if (!res.data.error) {
          // let data = {
          //     data: res.data.data,
          // };
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes_Bike(updatedData));
          //console.log(data)
          //dispatch(quick_quotes_Bike(data));
          dispatch(QuickQuote_Post(updatedQuotePost));
          setLoading(false);
          setisModalExp(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          //className="form-item-bg"
          name="previousPolicyExpiryDate"
          label="Select Policy Expiry Date"
          rules={[
            {
              required: true,
              message: "Please select Date",
            },
          ]}
          initialValue={moment(QuickQuotePost.previousPolicyExpiryDate)}
        >
          <DatePicker
            style={{ width: "100%", padding: "8px" }}
            // disabledDate={disabledDate}
            // onChange={handleDateChange}
            format="YYYY-MM-DD"
            placeholder="Select Expiry Date"
          />
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
